/**
 * Single Product Page JavaScript
 * Handles product gallery and interactions
 *
 * WooCommerce variable products replace gallery HTML on variation change; WAPF and other
 * plugins may swap images too. We re-sync .is-active, rebuild thumbnails, and re-init lightbox.
 */

(function () {
    let bpThumbSplide = null;
    let bpGLightboxInstance = null;

    function destroyBpGalleryExtras() {
        if (bpThumbSplide) {
            try {
                bpThumbSplide.destroy();
            } catch (e) { /* noop */ }
            bpThumbSplide = null;
        }
        document.querySelectorAll('.product-thumb-slider.splide').forEach(function (el) {
            el.remove();
        });
        if (bpGLightboxInstance && typeof bpGLightboxInstance.destroy === 'function') {
            try {
                bpGLightboxInstance.destroy();
            } catch (e) { /* noop */ }
            bpGLightboxInstance = null;
        }
    }

    function sharpGalleryUrl(img, imageDiv) {
        const src = img.getAttribute('src') || '';
        const link = imageDiv.querySelector('a');
        const full = link ? (link.getAttribute('href') || '') : '';
        let best = '';
        let bestWidth = 0;
        (img.getAttribute('srcset') || '').split(',').forEach(function (part) {
            const bits = part.trim().split(/\s+/);
            const width = parseInt(bits[1], 10);
            if (!bits[0] || !width || width < 480) {
                return;
            }
            if (!bestWidth || width < bestWidth) {
                best = bits[0];
                bestWidth = width;
            }
        });
        return best || src || full || imageDiv.getAttribute('data-thumb') || '';
    }

    /**
     * (Re)build gallery: visible slide, Splide thumbs, GLightbox.
     * Safe to call after WooCommerce updates .woocommerce-product-gallery__wrapper.
     */
    function initBpProductGallery() {
        const gallery = document.querySelector('.woocommerce-product-gallery');
        if (!gallery) {
            return;
        }

        gallery.style.opacity = '1';
        gallery.style.visibility = 'visible';

        destroyBpGalleryExtras();

        const galleryWrapper = gallery.querySelector('.woocommerce-product-gallery__wrapper');
        const mainImages = gallery.querySelectorAll('.woocommerce-product-gallery__image');

        if (!galleryWrapper || mainImages.length === 0) {
            return;
        }

        mainImages.forEach(function (m) {
            m.classList.remove('is-active');
        });
        mainImages[0].classList.add('is-active');

        if (mainImages.length > 1 && typeof Splide !== 'undefined') {
            const existingThumbs = gallery.querySelector('.flex-control-thumbs');
            if (existingThumbs) {
                existingThumbs.remove();
            }

            const thumbSlider = document.createElement('div');
            thumbSlider.className = 'product-thumb-slider splide';

            const thumbTrack = document.createElement('div');
            thumbTrack.className = 'splide__track';

            const thumbList = document.createElement('ul');
            thumbList.className = 'splide__list';

            mainImages.forEach(function (imageDiv, index) {
                const img = imageDiv.querySelector('img');
                if (!img) {
                    return;
                }
                const slide = document.createElement('li');
                slide.className = 'splide__slide';
                if (index === 0) {
                    slide.classList.add('is-active');
                }

                const thumbImg = document.createElement('img');
                thumbImg.src = sharpGalleryUrl(img, imageDiv);
                thumbImg.alt = img.alt || 'Product image ' + (index + 1);
                thumbImg.draggable = false;
                thumbImg.decoding = 'async';

                slide.appendChild(thumbImg);
                thumbList.appendChild(slide);

                slide.addEventListener('click', function () {
                    mainImages.forEach(function (m) {
                        m.classList.remove('is-active');
                    });
                    if (mainImages[index]) {
                        mainImages[index].classList.add('is-active');
                    }
                    thumbList.querySelectorAll('.splide__slide').forEach(function (s) {
                        s.classList.remove('is-active');
                    });
                    slide.classList.add('is-active');
                });
            });

            thumbTrack.appendChild(thumbList);
            thumbSlider.appendChild(thumbTrack);
            gallery.appendChild(thumbSlider);

            const thumbCount = thumbList.children.length;
            bpThumbSplide = new Splide(thumbSlider, {
                perPage: 5,
                perMove: 1,
                gap: '0.75rem',
                pagination: false,
                arrows: thumbCount > 5,
                isNavigation: false,
                trimSpace: true,
                i18n: {
                    prev: 'Ankstesnės nuotraukos',
                    next: 'Kitos nuotraukos'
                },
                breakpoints: {
                    768: { perPage: 4, gap: '0.5rem', arrows: thumbCount > 4 },
                    480: { perPage: 3, gap: '0.5rem', arrows: thumbCount > 3 }
                }
            });
            bpThumbSplide.mount();
        }

        const galleryImages = gallery.querySelectorAll('.woocommerce-product-gallery__image a');
        if (galleryImages.length > 0 && typeof GLightbox !== 'undefined') {
            galleryImages.forEach(function (link) {
                link.classList.add('glightbox');
                link.setAttribute('data-gallery', 'product-gallery');
                link.style.cursor = 'zoom-in';
            });
            bpGLightboxInstance = GLightbox({
                selector: '.woocommerce-product-gallery .glightbox',
                touchNavigation: true,
                loop: true,
                closeButton: true,
                zoomable: true,
                draggable: true,
                dragAutoSnap: true,
                dragToleranceX: 50,
                dragToleranceY: 50,
                preload: true,
                skin: 'clean',
                openEffect: 'fade',
                closeEffect: 'fade',
                slideEffect: 'slide',
                moreLength: 0,
                descPosition: 'bottom',
                lightboxHTML: '<div id="glightbox-body" class="glightbox-container"><div class="gloader visible"></div><div class="goverlay"></div><div class="gcontainer"><div id="glightbox-slider" class="gslider"></div><button class="gclose gbtn" aria-label="Close" data-taborder="3">{closeSVG}</button><button class="gprev gbtn" aria-label="Previous" data-taborder="2">{prevSVG}</button><button class="gnext gbtn" aria-label="Next" data-taborder="1">{nextSVG}</button></div></div>'
            });
        } else if (galleryImages.length > 0) {
            galleryImages.forEach(function (link) {
                link.style.cursor = 'zoom-in';
                link.addEventListener('click', function (e) {
                    e.preventDefault();
                    window.open(this.href, '_blank');
                });
            });
        }
    }

    let galleryRefreshTimer = null;
    function scheduleGalleryRefresh() {
        clearTimeout(galleryRefreshTimer);
        galleryRefreshTimer = setTimeout(function () {
            initBpProductGallery();
        }, 120);
    }

    document.addEventListener('DOMContentLoaded', function () {
        initBpProductGallery();

        // Only refresh when the gallery DOM actually changes — not on every WAPF field change.
        // WAPF "change product image" rules update slides or img src/href inside the wrapper.
        const wrapper = document.querySelector('.woocommerce-product-gallery__wrapper');
        if (wrapper && typeof MutationObserver !== 'undefined') {
            const obs = new MutationObserver(function () {
                scheduleGalleryRefresh();
            });
            obs.observe(wrapper, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['src', 'srcset', 'href']
            });
        }

        if (typeof jQuery !== 'undefined') {
            jQuery(document.body)
                .on('found_variation', 'form.variations_form', function () {
                    scheduleGalleryRefresh();
                })
                .on('reset_data hide_variation', 'form.variations_form', function () {
                    scheduleGalleryRefresh();
                });
        }
    });
})();

document.addEventListener('DOMContentLoaded', function() {

    initLetterExtrasWizard();
    initElfWizard();
    initProductBundle();

    // Quantity input enhancement
    const quantityInput = document.querySelector('input.qty');
    if (quantityInput) {
        // Create quantity buttons if they don't exist
        if (!quantityInput.parentElement.querySelector('.qty-btn')) {
            const quantityWrapper = quantityInput.parentElement;
            quantityWrapper.style.display = 'flex';
            quantityWrapper.style.alignItems = 'center';
            quantityWrapper.style.gap = '0.5rem';
            
            // Minus button
            const minusBtn = document.createElement('button');
            minusBtn.type = 'button';
            minusBtn.className = 'qty-btn qty-minus';
            minusBtn.innerHTML = '−';
            minusBtn.style.cssText = 'width: 2.5rem; height: 2.5rem; border: 2px solid #e0e0e0; background: #fff; border-radius: 0.5rem; cursor: pointer; font-size: 1.25rem; transition: all 0.3s ease;';
            
            // Plus button
            const plusBtn = document.createElement('button');
            plusBtn.type = 'button';
            plusBtn.className = 'qty-btn qty-plus';
            plusBtn.innerHTML = '+';
            plusBtn.style.cssText = 'width: 2.5rem; height: 2.5rem; border: 2px solid #e0e0e0; background: #fff; border-radius: 0.5rem; cursor: pointer; font-size: 1.25rem; transition: all 0.3s ease;';
            
            // Insert buttons
            quantityWrapper.insertBefore(minusBtn, quantityInput);
            quantityWrapper.appendChild(plusBtn);
            
            // Update input styling
            quantityInput.style.cssText = 'flex: 1; max-width: 80px; text-align: center;';
            
            // Button functionality
            minusBtn.addEventListener('click', function() {
                let value = parseInt(quantityInput.value) || 1;
                let min = parseInt(quantityInput.min) || 1;
                if (value > min) {
                    quantityInput.value = value - 1;
                    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
            
            plusBtn.addEventListener('click', function() {
                let value = parseInt(quantityInput.value) || 1;
                let max = parseInt(quantityInput.max) || 9999;
                if (value < max) {
                    quantityInput.value = value + 1;
                    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
            
            // Hover effects
            [minusBtn, plusBtn].forEach(btn => {
                btn.addEventListener('mouseenter', function() {
                    this.style.borderColor = '#BFB792';
                    this.style.backgroundColor = '#f9f9f9';
                });
                btn.addEventListener('mouseleave', function() {
                    this.style.borderColor = '#e0e0e0';
                    this.style.backgroundColor = '#fff';
                });
            });
        }
    }

    // WAPF number input enhancement - add +/- buttons like quantity selector
    const wapfNumberInputs = document.querySelectorAll('.wapf-field-number input[type="number"].wapf-input');
    wapfNumberInputs.forEach(input => {
        // Check if buttons already exist
        const wrapper = input.parentElement;
        if (wrapper.querySelector('.wapf-qty-btn')) {
            return; // Already enhanced
        }

        // Create wrapper if needed
        if (!wrapper.classList.contains('wapf-number-wrapper')) {
            wrapper.classList.add('wapf-number-wrapper');
            wrapper.style.display = 'flex';
            wrapper.style.alignItems = 'center';
            wrapper.style.gap = '0.5rem';
        }

        // Minus button
        const minusBtn = document.createElement('button');
        minusBtn.type = 'button';
        minusBtn.className = 'wapf-qty-btn wapf-qty-minus';
        minusBtn.innerHTML = '−';
        minusBtn.setAttribute('aria-label', 'Decrease value');

        // Plus button
        const plusBtn = document.createElement('button');
        plusBtn.type = 'button';
        plusBtn.className = 'wapf-qty-btn wapf-qty-plus';
        plusBtn.innerHTML = '+';
        plusBtn.setAttribute('aria-label', 'Increase value');

        // Insert buttons
        wrapper.insertBefore(minusBtn, input);
        wrapper.appendChild(plusBtn);

        // Update input styling
        input.style.cssText = 'flex: 1; max-width: 80px; text-align: center;';

        // Button functionality
        minusBtn.addEventListener('click', function() {
            let value = parseInt(input.value) || 0;
            let min = parseInt(input.min) || 0;
            if (value > min) {
                input.value = value - 1;
                input.dispatchEvent(new Event('change', { bubbles: true }));
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        });

        plusBtn.addEventListener('click', function() {
            let value = parseInt(input.value) || 0;
            let max = parseInt(input.max) || 9999;
            if (value < max) {
                input.value = value + 1;
                input.dispatchEvent(new Event('change', { bubbles: true }));
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        });

        // Hover effects
        [minusBtn, plusBtn].forEach(btn => {
            btn.addEventListener('mouseenter', function() {
                this.style.borderColor = '#BFB792';
                this.style.backgroundColor = '#f9f9f9';
            });
            btn.addEventListener('mouseleave', function() {
                this.style.borderColor = '#e0e0e0';
                this.style.backgroundColor = '#fff';
            });
        });
    });

    // Add to cart button loading state - only visual, doesn't interfere with WooCommerce
    const addToCartBtn = document.querySelector('.single_add_to_cart_button');
    if (addToCartBtn) {
        // Only add loading on button click (WooCommerce handles the rest)
        addToCartBtn.addEventListener('click', function() {
            if (!this.classList.contains('disabled')) {
                this.classList.add('loading');
            }
        });
        
        // Remove loading after successful add to cart (WooCommerce event)
        document.addEventListener('added_to_cart', function() {
            if (addToCartBtn) {
                addToCartBtn.classList.remove('loading');
                addToCartBtn.classList.add('added');
                
                setTimeout(() => {
                    addToCartBtn.classList.remove('added');
                }, 2000);
            }
        });
        
        // Safety: Remove loading if form validation prevents submission
        // This happens when browser shows validation message
        const cartForm = document.querySelector('form.cart');
        if (cartForm) {
            cartForm.setAttribute('novalidate', 'novalidate');
            cartForm.addEventListener('submit', function (event) {
                const field = firstInvalidField(cartForm.querySelectorAll('input, select, textarea'));
                if (!field) {
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
                addToCartBtn.classList.remove('loading');
                showFieldNotice(field);
            }, true);
            // Listen for invalid events - means validation failed
            cartForm.addEventListener('invalid', function(e) {
                // Remove loading if it was added
                if (addToCartBtn.classList.contains('loading')) {
                    addToCartBtn.classList.remove('loading');
                }
            }, true); // Use capture to catch all invalid events
            
            // Also check after a short delay if form didn't submit
            let submitCheckTimeout;
            cartForm.addEventListener('submit', function() {
                // If form actually submits, clear the check
                clearTimeout(submitCheckTimeout);
                
                // But if validation prevents it, this won't run
                // So check after a short delay
                submitCheckTimeout = setTimeout(function() {
                    // If still loading after 500ms and form didn't submit, remove it
                    if (addToCartBtn.classList.contains('loading')) {
                        // Check if form is invalid
                        if (!cartForm.checkValidity()) {
                            addToCartBtn.classList.remove('loading');
                        }
                    }
                }, 500);
            });
        }
    }

    // Smooth scroll to tabs
    const tabLinks = document.querySelectorAll('.woocommerce-tabs .tabs a');
    tabLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            setTimeout(() => {
                const target = document.querySelector(this.getAttribute('href'));
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 50);
        });
    });

    // ============================================================
    // WAPF Price Calculation Fallback
    // Ensures dynamic price updates work even if plugin JS fails
    // ============================================================
    const wapfTotals = document.querySelector('.wapf-product-totals');
    if (wapfTotals) {
        const productPrice = parseFloat(wapfTotals.getAttribute('data-product-price')) || 0;
        const quantityInput = document.querySelector('input.qty');
        
        // Format price for display
        function formatPrice(price) {
            return new Intl.NumberFormat('lt-LT', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(price);
        }

        // Calculate totals
        function calculateWapfTotals() {
            let optionsTotal = 0;
            const quantity = parseInt(quantityInput?.value || 1);

            // Get ALL WAPF input fields (not just those with data-wapf-price on the element itself)
            const wapfInputs = document.querySelectorAll('.wapf-input');
            
            wapfInputs.forEach(field => {
                if (field.tagName === 'SELECT' || field.type === 'select-one') {
                    const selectedOption = field.options[field.selectedIndex];
                    if (selectedOption && selectedOption.dataset && selectedOption.dataset.wapfPrice) {
                        const price = parseFloat(selectedOption.dataset.wapfPrice) || 0;
                        const priceType = selectedOption.dataset.wapfPricetype || 'qt';
                        optionsTotal += (priceType === 'fixed' ? price : price * quantity);
                    }
                }
                else if (field.type === 'number') {
                    const value = parseInt(field.value) || 0;
                    const pricePerUnit = parseFloat(field.dataset.wapfPrice) || 0;
                    const priceType = field.dataset.wapfPricetype || 'fixed';

                    if (priceType === 'nr' || priceType === 'nrq' || priceType === 'qt') {
                        optionsTotal += pricePerUnit * value * (priceType === 'nr' ? 1 : quantity);
                    } else if (value > 0) {
                        optionsTotal += pricePerUnit;
                    }
                }
                else if (field.type === 'checkbox') {
                    if (field.checked) {
                        const price = parseFloat(field.dataset.wapfPrice) || 0;
                        const priceType = field.dataset.wapfPricetype || 'qt';
                        optionsTotal += (priceType === 'fixed' ? price : price * quantity);
                    }
                }
                else if (field.type === 'radio' && field.checked) {
                    const price = parseFloat(field.dataset.wapfPrice) || 0;
                    const priceType = field.dataset.wapfPricetype || 'qt';
                    optionsTotal += (priceType === 'fixed' ? price : price * quantity);
                }
            });

            const productTotal = productPrice * quantity;
            const grandTotal = productTotal + optionsTotal;

            // Update DOM
            const productTotalEl = wapfTotals.querySelector('.wapf-product-total');
            const optionsTotalEl = wapfTotals.querySelector('.wapf-options-total');
            const grandTotalEl = wapfTotals.querySelector('.wapf-grand-total');

            if (productTotalEl) {
                productTotalEl.textContent = formatPrice(productTotal);
            }
            if (optionsTotalEl) {
                optionsTotalEl.textContent = formatPrice(optionsTotal);
            }
            if (grandTotalEl) {
                grandTotalEl.textContent = formatPrice(grandTotal);
            }
        }

        // Use event delegation on the form to catch all changes (including dynamically added fields)
        const cartForm = document.querySelector('form.cart');
        if (cartForm) {
            cartForm.addEventListener('change', function(e) {
                if (e.target.classList.contains('wapf-input') || e.target.classList.contains('qty')) {
                    calculateWapfTotals();
                }
            });
            
            cartForm.addEventListener('input', function(e) {
                if (e.target.classList.contains('wapf-input') || e.target.classList.contains('qty')) {
                    calculateWapfTotals();
                }
            });
        }

        // Also attach directly to existing fields as backup
        const wapfInputs = document.querySelectorAll('.wapf-input');
        wapfInputs.forEach(input => {
            input.addEventListener('change', calculateWapfTotals);
            input.addEventListener('input', calculateWapfTotals);
        });

        // Watch quantity changes
        if (quantityInput) {
            quantityInput.addEventListener('change', calculateWapfTotals);
            quantityInput.addEventListener('input', calculateWapfTotals);
        }

        // Initial calculation - run multiple times to ensure it catches everything
        setTimeout(() => {
            calculateWapfTotals();
        }, 100);
        
        setTimeout(() => {
            calculateWapfTotals();
        }, 500);

        // Also check if WAPF plugin initialized (give it 2 seconds)
        setTimeout(() => {
            const grandTotalEl = wapfTotals.querySelector('.wapf-grand-total');
            if (grandTotalEl && !grandTotalEl.textContent.trim()) {
                // Plugin didn't initialize, use our fallback
                console.log('WAPF plugin not initialized, using fallback calculation');
                calculateWapfTotals();
            } else {
                // Plugin might be working, but ensure our fallback also runs
                calculateWapfTotals();
            }
        }, 2000);
    }

    // ============================================================
    // Letter products: child data → extras cards (same form, no reload).
    // WAPF selects stay in the form for price/cart; cards write into them.
    // ============================================================
    function initLetterExtrasWizard() {
        const cfg = window.bpLetterExtras;
        if (!cfg || !cfg.enabled || !Array.isArray(cfg.extras) || cfg.extras.length === 0) {
            return;
        }

        const form = document.querySelector('.single-product-page form.cart, form.cart');
        if (!form || !form.querySelector('.wapf')) {
            return;
        }

        const i18n = cfg.i18n || {};
        const containers = Array.from(form.querySelectorAll('.wapf-field-container'));
        if (containers.length === 0) {
            return;
        }

        const cardsOnly = !!cfg.cardsOnly;
        const extraSelects = [];

        containers.forEach(function (container) {
            const labelEl = container.querySelector('.wapf-field-label');
            const label = (labelEl ? labelEl.textContent : container.textContent || '').toLowerCase();
            const isFootprint = /p[eė]dsak|pedsak|footprint/.test(label);
            const isExtra = !isFootprint && /priedai prie|optional extras|rakt|magic key|elni|reindeer|akin|glass|snieg|snow|saldain|candy|buteliuk|bottle|pad[eė]kl|padek|lentel|tray/.test(label);
            const treatAsExtra = cardsOnly ? isFootprint : isExtra;
            if (treatAsExtra) {
                container.classList.add('kp-letter-wizard-field--extra');
                const select = container.querySelector('select.wapf-input');
                const numberInput = container.querySelector('input[type="number"].wapf-input');
                if (select) {
                    extraSelects.push({ container: container, control: select, kind: 'select', label: label });
                } else if (numberInput && cfg.openQty) {
                    extraSelects.push({ container: container, control: numberInput, kind: 'number', label: label });
                }
            } else if (!cardsOnly) {
                container.classList.add('kp-letter-wizard-field--child');
            }
        });

        if (extraSelects.length === 0) {
            return;
        }

        if (Array.isArray(cfg.cardOrder) && cfg.cardOrder.length) {
            extraSelects.sort(function (a, b) {
                const ia = cfg.cardOrder.indexOf(extraSlug(a.label, cfg.extras));
                const ib = cfg.cardOrder.indexOf(extraSlug(b.label, cfg.extras));
                return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
            });
        }

        form.classList.add('kp-letter-wizard');
        if (cardsOnly) {
            form.classList.add('kp-letter-wizard--cards');
        } else {
            form.classList.add('kp-letter-wizard--step-1');
        }

        let steps = null;
        if (!cfg.embedded && !cardsOnly) {
            steps = document.createElement('nav');
            steps.className = 'kp-letter-wizard__steps';
            steps.setAttribute('aria-label', i18n.stepsLabel || 'Užsakymo žingsniai');
            steps.innerHTML =
                '<ol class="kp-letter-wizard__steps-list">' +
                    '<li class="kp-letter-wizard__step is-active" data-step="1" aria-current="step">' +
                        '<span class="kp-letter-wizard__step-num" aria-hidden="true">1</span>' +
                        '<span class="kp-letter-wizard__step-label">' + escapeHtml(i18n.step1 || 'Vaiko duomenys') + '</span>' +
                    '</li>' +
                    '<li class="kp-letter-wizard__step-sep" aria-hidden="true"></li>' +
                    '<li class="kp-letter-wizard__step" data-step="2">' +
                        '<span class="kp-letter-wizard__step-num" aria-hidden="true">2</span>' +
                        '<span class="kp-letter-wizard__step-label">' + escapeHtml(i18n.step2 || 'Priedai') + '</span>' +
                    '</li>' +
                '</ol>';
            form.insertBefore(steps, form.firstChild);
        }

        const extrasWrap = document.createElement('div');
        extrasWrap.className = 'kp-letter-wizard__extras';
        extrasWrap.innerHTML =
            '<h2 class="kp-letter-wizard__extras-title">' + escapeHtml(i18n.extrasHeading || 'Papildomi priedai') + '</h2>' +
            '<p class="kp-letter-wizard__extras-intro">' + escapeHtml(i18n.extrasIntro || '') + '</p>' +
            '<div class="kp-letter-wizard__cards"></div>';
        const cardsRoot = extrasWrap.querySelector('.kp-letter-wizard__cards');

        extraSelects.forEach(function (item) {
            const meta = cfg.extras.find(function (extra) {
                if (!extra.match) {
                    return false;
                }
                try {
                    return new RegExp(extra.match, 'i').test(item.label);
                } catch (err) {
                    return item.label.indexOf(String(extra.match).toLowerCase()) !== -1;
                }
            }) || {};
            cardsRoot.appendChild(buildExtraCard(item.control, meta, i18n, item.kind, cfg.openQtyMax));
        });

        const wapfRoot = form.querySelector('.wapf');
        if (wapfRoot && wapfRoot.parentNode) {
            wapfRoot.parentNode.insertBefore(extrasWrap, wapfRoot);
        } else {
            form.appendChild(extrasWrap);
        }

        if (cfg.embedded || cardsOnly) {
            return;
        }

        const actions = document.createElement('div');
        actions.className = 'kp-letter-wizard__actions';
        const backBtn = document.createElement('button');
        backBtn.type = 'button';
        backBtn.className = 'kp-letter-wizard__back';
        backBtn.textContent = i18n.back || 'Atgal';
        const nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'kp-letter-wizard__next';
        nextBtn.textContent = i18n.next || 'Toliau';
        const addToCart = form.querySelector('.single_add_to_cart_button');
        actions.appendChild(backBtn);
        actions.appendChild(nextBtn);
        if (addToCart) {
            actions.appendChild(addToCart);
        }

        const quantity = form.querySelector('.quantity');
        if (quantity && quantity.parentNode) {
            quantity.parentNode.insertBefore(actions, quantity.nextSibling);
        } else {
            form.appendChild(actions);
        }

        function setStep(step) {
            form.classList.toggle('kp-letter-wizard--step-1', step === 1);
            form.classList.toggle('kp-letter-wizard--step-2', step === 2);
            steps.querySelectorAll('.kp-letter-wizard__step').forEach(function (el) {
                const n = parseInt(el.getAttribute('data-step'), 10);
                el.classList.toggle('is-active', n === step);
                el.classList.toggle('is-complete', n < step);
                if (n === step) {
                    el.setAttribute('aria-current', 'step');
                } else {
                    el.removeAttribute('aria-current');
                }
            });
            steps.classList.toggle('is-step-2', step === 2);
            const target = step === 2 ? extrasWrap : form.querySelector('.kp-letter-wizard-field--child');
            if (target && typeof target.scrollIntoView === 'function') {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }

        nextBtn.addEventListener('click', function () {
            const childFields = form.querySelectorAll('.kp-letter-wizard-field--child input, .kp-letter-wizard-field--child select, .kp-letter-wizard-field--child textarea');
            const field = firstInvalidField(childFields);
            if (field) {
                showFieldNotice(field);
                return;
            }
            clearFieldNotices(form);
            setStep(2);
        });

        backBtn.addEventListener('click', function () {
            setStep(1);
        });
    }

    function extraSlug(label, extras) {
        let slug = '';
        (extras || []).some(function (extra) {
            if (!extra || !extra.match || !extra.slug) {
                return false;
            }
            try {
                if (new RegExp(extra.match, 'i').test(label)) {
                    slug = extra.slug;
                    return true;
                }
            } catch (err) {
                return false;
            }
            return false;
        });
        return slug;
    }

    function buildExtraCard(select, meta, i18n, kind, openMax) {
        const isNumber = kind === 'number';
        const attrMax = isNumber ? parseInt(select.getAttribute('max'), 10) : 0;
        const maxQty = isNumber
            ? (attrMax > 0 ? attrMax : (parseInt(openMax, 10) || 99))
            : Math.max(0, select.options.length - 1);
        const card = document.createElement('div');
        card.className = 'kp-letter-extra-card';

        const unitPrice = isNumber ? unitPriceFromNumber(select) : unitPriceFromSelect(select);
        const title = meta.title || (select.closest('.wapf-field-container') && select.closest('.wapf-field-container').querySelector('.wapf-field-label')
            ? select.closest('.wapf-field-container').querySelector('.wapf-field-label').textContent.replace(/\*/g, '').trim()
            : 'Priedas');

        let imgHtml = '';
        if (meta.image) {
            const pos = meta.imagePosition ? String(meta.imagePosition) : '50% 82%';
            imgHtml = '<div class="kp-letter-extra-card__media" style="--kp-extra-img-pos:' + escapeHtml(pos) + '"><img src="' + escapeHtml(meta.image) + '" alt="' + escapeHtml(title) + '"></div>';
        }

        card.innerHTML =
            imgHtml +
            '<div class="kp-letter-extra-card__body">' +
                '<h3 class="kp-letter-extra-card__title">' + escapeHtml(title) + '</h3>' +
                (meta.blurb ? '<p class="kp-letter-extra-card__blurb">' + escapeHtml(meta.blurb) + '</p>' : '') +
                (unitPrice > 0 ? '<p class="kp-letter-extra-card__price">+' + formatEuro(unitPrice) + ' <span>' + escapeHtml(i18n.perItem || '/ vnt.') + '</span></p>' : '') +
                '<div class="kp-letter-extra-card__qty">' +
                    '<button type="button" class="kp-letter-extra-card__qty-btn" data-dir="-1" aria-label="' + escapeHtml(i18n.decrease || 'Mažinti') + '">−</button>' +
                    '<span class="kp-letter-extra-card__qty-value" aria-live="polite">0</span>' +
                    '<button type="button" class="kp-letter-extra-card__qty-btn" data-dir="1" aria-label="' + escapeHtml(i18n.increase || 'Didinti') + '">+</button>' +
                '</div>' +
            '</div>';

        const valueEl = card.querySelector('.kp-letter-extra-card__qty-value');

        function currentQty() {
            if (isNumber) {
                return Math.max(0, parseInt(select.value, 10) || 0);
            }
            return Math.max(0, select.selectedIndex);
        }

        function applyQty(qty) {
            const next = Math.max(0, Math.min(maxQty, qty));
            if (isNumber) {
                const written = next === 0 ? '' : String(next);
                if (select.value !== written) {
                    select.value = written;
                    select.dispatchEvent(new Event('input', { bubbles: true }));
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                }
            } else if (select.selectedIndex !== next) {
                select.selectedIndex = next;
                select.dispatchEvent(new Event('change', { bubbles: true }));
            }
            valueEl.textContent = String(next);
            card.classList.toggle('is-selected', next > 0);
            const minus = card.querySelector('[data-dir="-1"]');
            const plus = card.querySelector('[data-dir="1"]');
            if (minus) {
                minus.disabled = next <= 0;
            }
            if (plus) {
                plus.disabled = next >= maxQty;
            }
        }

        card.querySelectorAll('.kp-letter-extra-card__qty-btn').forEach(function (btn) {
            btn.addEventListener('click', function () {
                const dir = parseInt(btn.getAttribute('data-dir'), 10) || 0;
                applyQty(currentQty() + dir);
            });
        });

        select.addEventListener('change', function () {
            applyQty(currentQty());
        });

        applyQty(currentQty());
        return card;
    }

    function unitPriceFromNumber(input) {
        const raw = input.getAttribute('data-wapf-price') || (input.dataset && input.dataset.wapfPrice) || '';
        const price = parseFloat(raw);
        return !isNaN(price) && price > 0 ? price : 0;
    }

    function unitPriceFromSelect(select) {
        for (let i = 1; i < select.options.length; i++) {
            const opt = select.options[i];
            const raw = opt.getAttribute('data-wapf-price') || (opt.dataset && opt.dataset.wapfPrice) || '';
            let price = parseFloat(raw);
            if (isNaN(price) && raw && raw.charAt(0) === '{') {
                try {
                    const parsed = JSON.parse(raw);
                    price = parseFloat(parsed.amount || parsed.price || 0);
                } catch (e) {
                    price = NaN;
                }
            }
            if ((isNaN(price) || price <= 0) && opt.textContent) {
                const m = opt.textContent.replace(/\s/g, ' ').match(/(\d+[.,]\d+)/);
                if (m) {
                    price = parseFloat(m[1].replace(',', '.'));
                }
            }
            if (!isNaN(price) && price > 0) {
                const qtyMatch = (opt.textContent || '').match(/(\d+)\s*vnt/i);
                const qty = qtyMatch ? parseInt(qtyMatch[1], 10) : i;
                return qty > 0 ? price / qty : price / i;
            }
        }
        return 0;
    }

    function selectedOptionPrice(select) {
        const opt = select.options[select.selectedIndex];
        if (!opt || select.selectedIndex <= 0) {
            return 0;
        }
        const raw = opt.getAttribute('data-wapf-price') || (opt.dataset && opt.dataset.wapfPrice) || '';
        let price = parseFloat(raw);
        if (isNaN(price) && raw && raw.charAt(0) === '{') {
            try {
                const parsed = JSON.parse(raw);
                price = parseFloat(parsed.amount || parsed.price || 0);
            } catch (e) {
                price = NaN;
            }
        }
        if ((isNaN(price) || price <= 0) && opt.textContent) {
            const match = opt.textContent.replace(/\s/g, ' ').match(/(\d+[.,]\d+)/);
            if (match) {
                price = parseFloat(match[1].replace(',', '.'));
            }
        }
        return !isNaN(price) && price > 0 ? price : 0;
    }

    function formatEuro(amount) {
        try {
            return new Intl.NumberFormat('lt-LT', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(amount);
        } catch (e) {
            return amount.toFixed(2).replace('.', ',') + ' €';
        }
    }

    function fieldNoticeMessage(field) {
        const english = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
        const validity = field.validity || {};
        if (validity.valueMissing) {
            if (field.tagName === 'SELECT') {
                return english ? 'Please select an item.' : 'Pasirinkite reikšmę.';
            }
            return english ? 'Please fill in this field.' : 'Užpildykite šį lauką.';
        }
        if (validity.badInput || validity.rangeUnderflow || validity.rangeOverflow || validity.stepMismatch) {
            return english ? 'Please enter a valid number.' : 'Įveskite tinkamą skaičių.';
        }
        if (validity.typeMismatch) {
            return english ? 'Please enter a valid value.' : 'Įveskite teisingą reikšmę.';
        }
        return english ? 'Please check this field.' : 'Patikrinkite šį lauką.';
    }

    function fieldIsCheckable(field) {
        if (!field || field.disabled || field.type === 'hidden' || field.type === 'button' || field.type === 'submit') {
            return false;
        }
        if (typeof field.checkValidity !== 'function' || field.willValidate === false) {
            return false;
        }
        const box = field.closest('.wapf-field-container') || field;
        return box.offsetParent !== null;
    }

    function clearFieldNotices(root) {
        const scope = root || document;
        scope.querySelectorAll('.kp-field-notice').forEach(function (el) {
            el.remove();
        });
        scope.querySelectorAll('.is-kp-invalid').forEach(function (el) {
            el.classList.remove('is-kp-invalid');
        });
    }

    function showFieldNotice(field) {
        const form = field.form || field.closest('form') || document;
        clearFieldNotices(form);
        const container = field.closest('.wapf-field-container') || field.parentElement;
        if (container) {
            container.classList.add('is-kp-invalid');
        }
        const note = document.createElement('div');
        note.className = 'kp-field-notice';
        note.setAttribute('role', 'alert');
        note.innerHTML = '<span class="kp-field-notice__mark" aria-hidden="true">!</span><span>' + escapeHtml(fieldNoticeMessage(field)) + '</span>';
        const anchor = field.closest('.wapf-field-input') || field;
        anchor.insertAdjacentElement('afterend', note);
        if (typeof field.focus === 'function') {
            field.focus({ preventScroll: true });
        }
        if (typeof field.scrollIntoView === 'function') {
            field.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        function hideWhenValid() {
            if (typeof field.checkValidity === 'function' && !field.checkValidity()) {
                return;
            }
            note.remove();
            if (container) {
                container.classList.remove('is-kp-invalid');
            }
            field.removeEventListener('input', hideWhenValid);
            field.removeEventListener('change', hideWhenValid);
        }
        field.addEventListener('input', hideWhenValid);
        field.addEventListener('change', hideWhenValid);
    }

    function firstInvalidField(list) {
        for (let i = 0; i < list.length; i++) {
            const field = list[i];
            if (!fieldIsCheckable(field)) {
                continue;
            }
            if (!field.checkValidity()) {
                return field;
            }
        }
        return null;
    }

    function escapeHtml(str) {
        return String(str == null ? '' : str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    // ============================================================
    // Elf kit: optional type cards, gender only after an elf is chosen. Standalone elves: gender only.
    // WAPF selects stay in the form for price/cart; cards write into them.
    // ============================================================
    function initElfWizard(explicitForm, explicitCfg) {
        const cfg = explicitCfg || window.bpElfWizard;
        if (!cfg || !cfg.mode) {
            return;
        }

        const form = explicitForm || document.querySelector('.single-product-page form.cart, form.cart');
        if (!form || !form.querySelector('.wapf')) {
            return;
        }

        const i18n = cfg.i18n || {};
        const containers = Array.from(form.querySelectorAll('.wapf-field-container'));
        if (containers.length === 0) {
            return;
        }

        let typeSelect = null;
        let typeChecks = [];
        let genderSelect = null;

        containers.forEach(function (container) {
            const labelEl = container.querySelector('.wapf-field-label');
            const label = (labelEl ? labelEl.textContent : container.textContent || '').toLowerCase();
            const select = container.querySelector('select.wapf-input');
            const checks = Array.from(container.querySelectorAll('input.wapf-input[type="checkbox"]'));
            if (cfg.typeMatch && new RegExp(cfg.typeMatch, 'i').test(label) && (checks.length || select)) {
                if (checks.length) {
                    typeChecks = checks;
                } else {
                    typeSelect = select;
                }
                container.classList.add('kp-elf-wizard-field');
            } else if (select && cfg.genderMatch && new RegExp(cfg.genderMatch, 'i').test(label)) {
                genderSelect = select;
                container.classList.add('kp-elf-wizard-field');
            }
        });

        if (cfg.mode === 'kit' && !typeSelect && !typeChecks.length) {
            return;
        }
        if (cfg.mode === 'gender' && !genderSelect) {
            return;
        }

        form.classList.add('kp-elf-wizard');
        if (cfg.mode === 'gender') {
            form.classList.add('kp-elf-wizard--gender-only');
        }
        if (typeSelect) {
            typeSelect.required = false;
        }
        typeChecks.forEach(function (input) {
            input.required = false;
        });
        if (genderSelect) {
            genderSelect.required = false;
        }

        const wrap = document.createElement('div');
        wrap.className = 'kp-elf-wizard__wrap';
        const requiredMark = '<span class="kp-elf-wizard__required" aria-hidden="true">*</span>';

        let typesBlock = null;
        if (cfg.mode === 'kit' && Array.isArray(cfg.types) && cfg.types.length) {
            typesBlock = document.createElement('div');
            typesBlock.className = 'kp-elf-wizard__types';
            typesBlock.innerHTML =
                '<h2 class="kp-elf-wizard__title">' + escapeHtml(i18n.heading || 'Ar pridėti elfą?') + '</h2>' +
                '<p class="kp-elf-wizard__intro">' + escapeHtml(i18n.intro || '') + '</p>' +
                '<div class="kp-elf-wizard__cards kp-elf-wizard__cards--types"></div>' +
                '<p class="kp-elf-wizard__error" hidden></p>';
            const cardsRoot = typesBlock.querySelector('.kp-elf-wizard__cards');
            cfg.types.forEach(function (meta) {
                const control = typeChecks.find(function (input) {
                    return input.value === String(meta.slug || '');
                }) || typeSelect;
                if (control) {
                    cardsRoot.appendChild(buildElfChoiceCard(control, meta, i18n, 'type'));
                }
            });
            wrap.appendChild(typesBlock);
        }

        const genderBlock = document.createElement('div');
        genderBlock.className = 'kp-elf-wizard__gender';
        genderBlock.hidden = cfg.mode === 'kit';
        genderBlock.innerHTML =
            '<h2 class="kp-elf-wizard__title">' + escapeHtml(i18n.genderHeading || 'Elfo lytis') + requiredMark + '</h2>' +
            '<p class="kp-elf-wizard__intro">' + escapeHtml(i18n.genderIntro || '') + '</p>' +
            '<div class="kp-elf-wizard__cards kp-elf-wizard__cards--gender"></div>' +
            '<p class="kp-elf-wizard__error kp-elf-wizard__error--gender" hidden></p>';
        const genderRoot = genderBlock.querySelector('.kp-elf-wizard__cards');
        if (genderSelect && Array.isArray(cfg.genders)) {
            cfg.genders.forEach(function (meta) {
                genderRoot.appendChild(buildElfChoiceCard(genderSelect, meta, i18n, 'gender'));
            });
        }
        wrap.appendChild(genderBlock);

        const wapfRoot = form.querySelector('.wapf');
        if (wapfRoot && wapfRoot.parentNode) {
            wapfRoot.parentNode.insertBefore(wrap, wapfRoot);
        } else {
            form.insertBefore(wrap, form.firstChild);
        }

        function selectedTypeMetas() {
            if (!Array.isArray(cfg.types)) {
                return [];
            }
            if (typeChecks.length) {
                const slugs = typeChecks.filter(function (input) {
                    return input.checked;
                }).map(function (input) {
                    return input.value;
                });
                return cfg.types.filter(function (item) {
                    return slugs.indexOf(item.slug) !== -1;
                });
            }
            if (!typeSelect) {
                return [];
            }
            const slug = optionSlug(typeSelect);
            const meta = cfg.types.find(function (item) {
                return item.slug === slug;
            });
            return meta ? [meta] : [];
        }

        function needsGenderNow() {
            return !!(genderSelect && selectedTypeMetas().some(function (item) {
                return item.gender;
            }));
        }

        function syncGenderVisibility() {
            if (cfg.mode !== 'kit') {
                genderBlock.hidden = false;
                return;
            }
            const needsGender = needsGenderNow();
            genderBlock.hidden = !needsGender;
            if (!needsGender && genderSelect) {
                setSelectSlug(genderSelect, '');
                genderBlock.querySelectorAll('.kp-elf-choice-card').forEach(function (card) {
                    card.classList.remove('is-selected');
                    card.setAttribute('aria-pressed', 'false');
                });
            }
        }

        if (typeSelect) {
            typeSelect.addEventListener('change', syncGenderVisibility);
        }
        typeChecks.forEach(function (input) {
            input.addEventListener('change', syncGenderVisibility);
        });
        if (cfg.mode === 'kit' && typeSelect && optionSlug(typeSelect) === 'none') {
            let emptyOpt = null;
            for (let i = 0; i < typeSelect.options.length; i++) {
                if (typeSelect.options[i].value === '') {
                    emptyOpt = typeSelect.options[i];
                    break;
                }
            }
            if (!emptyOpt) {
                emptyOpt = new Option('Pasirinkite', '', true, true);
                typeSelect.insertBefore(emptyOpt, typeSelect.firstChild);
            }
            setSelectSlug(typeSelect, '');
        }
        syncGenderVisibility();

        const addToCart = form.querySelector('.single_add_to_cart_button');
        const typeError = wrap.querySelector('.kp-elf-wizard__error:not(.kp-elf-wizard__error--gender)');
        const genderError = wrap.querySelector('.kp-elf-wizard__error--gender');
        const typeCards = wrap.querySelector('.kp-elf-wizard__cards--types');
        const genderCards = wrap.querySelector('.kp-elf-wizard__cards--gender');
        let ctaHint = null;
        let ctaHintText = null;

        if (cfg.mode === 'kit' && addToCart) {
            ctaHint = document.createElement('p');
            ctaHint.className = 'kp-elf-wizard__cta-hint';
            ctaHint.id = 'kp-elf-wizard-cta-hint';
            ctaHint.setAttribute('role', 'status');
            ctaHint.innerHTML =
                '<span class="kp-elf-wizard__cta-hint-icon" aria-hidden="true">' +
                    '<svg width="18" height="18" viewBox="0 0 18 18" fill="none">' +
                        '<circle cx="9" cy="9" r="7.25" stroke="currentColor" stroke-width="1.5"/>' +
                        '<path d="M9 8.2V13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
                        '<circle cx="9" cy="5.6" r="0.95" fill="currentColor"/>' +
                    '</svg>' +
                '</span>' +
                '<span class="kp-elf-wizard__cta-hint-text"></span>';
            ctaHintText = ctaHint.querySelector('.kp-elf-wizard__cta-hint-text');
            addToCart.parentNode.insertBefore(ctaHint, addToCart);
            addToCart.setAttribute('aria-describedby', 'kp-elf-wizard-cta-hint');
        }

        function kitReadyToSubmit() {
            if (cfg.mode !== 'kit') {
                return true;
            }
            if (needsGenderNow() && !optionSlug(genderSelect)) {
                return false;
            }
            return true;
        }

        function missingChoiceTarget() {
            const needsGender = cfg.mode === 'gender' || (cfg.mode === 'kit' && needsGenderNow());
            if (needsGender && genderSelect && !optionSlug(genderSelect)) {
                return {
                    section: genderBlock,
                    cards: genderCards,
                    error: genderError,
                    message: i18n.genderRequired || i18n.ctaGenderHint || '',
                };
            }
            return null;
        }

        function hideChoiceErrors() {
            if (typeError) {
                typeError.hidden = true;
            }
            if (genderError) {
                genderError.hidden = true;
            }
            if (typeCards) {
                typeCards.classList.remove('is-attention');
            }
            if (genderCards) {
                genderCards.classList.remove('is-attention');
            }
            if (ctaHint) {
                ctaHint.classList.remove('is-alert');
            }
        }

        function nudgeRequiredChoice() {
            const target = missingChoiceTarget();
            if (!target || !target.section) {
                return;
            }
            genderBlock.hidden = target.section !== genderBlock ? genderBlock.hidden : false;
            if (target.error) {
                target.error.textContent = target.message;
                target.error.hidden = false;
            }
            if (ctaHint && ctaHintText) {
                ctaHintText.textContent = target.message;
                ctaHint.hidden = false;
                ctaHint.classList.add('is-alert');
            }
            target.section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            window.setTimeout(function () {
                if (target.cards) {
                    target.cards.classList.remove('is-attention');
                    void target.cards.offsetWidth;
                    target.cards.classList.add('is-attention');
                }
                const firstCard = target.section.querySelector('.kp-elf-choice-card');
                if (firstCard && typeof firstCard.focus === 'function') {
                    firstCard.focus({ preventScroll: true });
                }
            }, 280);
            window.setTimeout(function () {
                if (target.cards) {
                    target.cards.classList.remove('is-attention');
                }
            }, 2200);
        }

        function syncAddToCartState() {
            const typeMetas = selectedTypeMetas();
            const genderChosen = !!(genderSelect && optionSlug(genderSelect));
            if (typeCards) {
                typeCards.classList.toggle('has-selection', typeMetas.length > 0);
            }
            if (typesBlock) {
                typesBlock.classList.toggle('is-complete', typeMetas.length > 0);
            }
            if (genderCards) {
                genderCards.classList.toggle('has-selection', genderChosen);
            }
            genderBlock.classList.toggle('is-complete', genderChosen);

            if (!addToCart || cfg.mode !== 'kit') {
                return;
            }

            const ready = kitReadyToSubmit();
            addToCart.disabled = false;
            addToCart.classList.toggle('is-waiting-choice', !ready);
            addToCart.setAttribute('aria-disabled', ready ? 'false' : 'true');

            if (ctaHint && ctaHintText) {
                ctaHint.classList.remove('is-alert');
                if (ready) {
                    ctaHint.hidden = true;
                } else {
                    const needsGender = needsGenderNow() && !genderChosen;
                    ctaHintText.textContent = needsGender
                        ? (i18n.ctaGenderHint || i18n.genderRequired || '')
                        : (i18n.ctaHint || i18n.required || '');
                    ctaHint.hidden = false;
                }
            }

            if (ready) {
                hideChoiceErrors();
            }
        }

        if (typeSelect) {
            typeSelect.addEventListener('change', syncAddToCartState);
        }
        typeChecks.forEach(function (input) {
            input.addEventListener('change', syncAddToCartState);
        });
        if (genderSelect) {
            genderSelect.addEventListener('change', syncAddToCartState);
        }
        syncAddToCartState();

        if (addToCart && cfg.mode === 'kit') {
            addToCart.addEventListener('click', function (event) {
                if (kitReadyToSubmit()) {
                    return;
                }
                event.preventDefault();
                event.stopImmediatePropagation();
                nudgeRequiredChoice();
            }, true);
        }

        form.addEventListener('submit', function (event) {
            const target = missingChoiceTarget();
            if (!target) {
                hideChoiceErrors();
                return;
            }
            event.preventDefault();
            nudgeRequiredChoice();
        });

        mountKitFootprintsCard(form, containers, cfg);
    }

    function mountKitFootprintsCard(form, containers, cfg) {
        const spec = cfg && cfg.footprints;
        if (!spec || !spec.match || !form || !containers) {
            return;
        }
        let matcher;
        try {
            matcher = new RegExp(spec.match, 'i');
        } catch (err) {
            return;
        }
        containers.forEach(function (container) {
            if (container.getAttribute('data-footprints-card') === '1') {
                return;
            }
            const labelEl = container.querySelector('.wapf-field-label');
            const label = labelEl ? labelEl.textContent : '';
            if (!matcher.test(label)) {
                return;
            }
            const select = container.querySelector('select.wapf-input');
            if (!select) {
                return;
            }
            container.setAttribute('data-footprints-card', '1');
            container.classList.add('kp-elf-wizard-field', 'kp-elf-wizard-field--footprints');
            const descEl = container.querySelector('.wapf-field-description, .wapf-description');
            const card = buildExtraCard(select, {
                title: spec.title || label.replace(/\*/g, '').trim(),
                blurb: descEl ? descEl.textContent.trim() : (spec.blurb || ''),
                image: spec.image || '',
                imagePosition: spec.imagePosition || '50% 50%'
            }, {
                perItem: spec.perItem || '/ vnt.',
                decrease: spec.decrease || 'Mažinti kiekį',
                increase: spec.increase || 'Didinti kiekį'
            });
            card.classList.add('kp-elf-footprints-card');
            if (form.closest('.bp-bundle')) {
                card.classList.add('bp-bundle-elf-extra');
            }
            if (container.parentNode) {
                container.parentNode.insertBefore(card, container);
            }
        });
    }

    function optionSlug(select) {
        const opt = select.options[select.selectedIndex];
        if (!opt || opt.value === '') {
            return '';
        }
        return String(opt.value);
    }

    function setSelectSlug(select, slug) {
        const target = String(slug || '');
        let matched = false;
        for (let i = 0; i < select.options.length; i++) {
            if (select.options[i].value === target) {
                if (select.selectedIndex !== i) {
                    select.selectedIndex = i;
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                }
                matched = true;
                break;
            }
        }
        if (!matched && target === '' && select.value !== '') {
            select.selectedIndex = 0;
            select.value = '';
            select.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    function buildElfChoiceCard(select, meta, i18n, kind) {
        const card = document.createElement('button');
        card.type = 'button';
        card.className = 'kp-elf-choice-card';
        card.setAttribute('data-slug', meta.slug || '');
        card.setAttribute('aria-pressed', 'false');

        const price = typeof meta.price === 'number' ? meta.price : 0;
        let priceHtml = '';
        if (kind === 'type') {
            if (price > 0) {
                priceHtml = '<p class="kp-elf-choice-card__price">+' + formatEuro(price) + '</p>';
            } else {
                priceHtml = '<p class="kp-elf-choice-card__price kp-elf-choice-card__price--included">' + escapeHtml(i18n.included || '') + '</p>';
            }
        }

        let imgHtml = '';
        if (kind !== 'gender' && meta.image) {
            imgHtml = '<div class="kp-elf-choice-card__media"><img src="' + escapeHtml(meta.image) + '" alt="' + escapeHtml(meta.title || '') + '"></div>';
        }

        card.innerHTML =
            '<span class="kp-elf-choice-card__mark" aria-hidden="true"></span>' +
            imgHtml +
            '<div class="kp-elf-choice-card__body">' +
                '<h3 class="kp-elf-choice-card__title">' + escapeHtml(meta.title || '') + '</h3>' +
                (meta.blurb ? '<p class="kp-elf-choice-card__blurb">' + escapeHtml(meta.blurb) + '</p>' : '') +
                priceHtml +
            '</div>';

        function syncSelected() {
            const selected = select.type === 'checkbox'
                ? select.checked
                : optionSlug(select) === String(meta.slug || '');
            card.classList.toggle('is-selected', selected);
            card.setAttribute('aria-pressed', selected ? 'true' : 'false');
        }

        card.addEventListener('click', function () {
            const slug = String(meta.slug || '');
            if (select.type === 'checkbox') {
                select.checked = !select.checked;
                select.dispatchEvent(new Event('change', { bubbles: true }));
                const section = card.closest('.kp-elf-wizard__types, .kp-elf-wizard__gender');
                if (section) {
                    const msg = section.querySelector('.kp-elf-wizard__error');
                    if (msg) {
                        msg.hidden = true;
                    }
                }
                return;
            }
            if (kind === 'type' && optionSlug(select) === slug) {
                setSelectSlug(select, '');
                card.classList.remove('is-selected');
                card.setAttribute('aria-pressed', 'false');
                return;
            }
            setSelectSlug(select, slug);
            const group = card.closest('.kp-elf-wizard__cards');
            if (group) {
                group.querySelectorAll('.kp-elf-choice-card').forEach(function (el) {
                    const on = el === card;
                    el.classList.toggle('is-selected', on);
                    el.setAttribute('aria-pressed', on ? 'true' : 'false');
                });
            }
            const section = card.closest('.kp-elf-wizard__types, .kp-elf-wizard__gender');
            if (section) {
                const msg = section.querySelector('.kp-elf-wizard__error');
                if (msg) {
                    msg.hidden = true;
                }
            }
        });

        select.addEventListener('change', syncSelected);
        syncSelected();
        return card;
    }

    // ============================================================
    // Related Products Slider
    // Wrap default WooCommerce related products in Splide slider
    // ============================================================
    const relatedProductsSection = document.querySelector('.related.products');
    if (relatedProductsSection && typeof Splide !== 'undefined') {
        const productsList = relatedProductsSection.querySelector('ul.products');
        
        if (productsList && productsList.children.length > 0) {
            // IMPORTANT:
            // Do NOT iterate `firstChild` here because WooCommerce outputs whitespace text nodes
            // between <li> elements. Wrapping those text nodes into Splide slides creates empty
            // slides that break alignment and loop behavior.

            // Collect only actual product <li> elements (ignore text nodes).
            const productItems = Array.from(productsList.children).filter((el) => {
                return el && el.nodeType === 1 && el.classList && el.classList.contains('product');
            });

            if (productItems.length === 0) {
                return;
            }

            // Create slider wrapper structure
            const sliderWrapper = document.createElement('div');
            sliderWrapper.className = 'related-products__slider splide';
            
            const track = document.createElement('div');
            track.className = 'splide__track';
            
            const list = document.createElement('ul');
            list.className = 'splide__list';
            
            // Move product <li> elements into slides (no empties possible).
            productItems.forEach((productItem) => {
                const slide = document.createElement('li');
                slide.className = 'splide__slide';
                slide.appendChild(productItem);
                list.appendChild(slide);
            });
            
            // Build slider structure
            track.appendChild(list);
            sliderWrapper.appendChild(track);
            
            // Add arrows
            const arrows = document.createElement('div');
            arrows.className = 'splide__arrows';
            arrows.innerHTML = `
                <button class="splide__arrow splide__arrow--prev" type="button" aria-label="Ankstesni produktai">
                    <svg width="24" height="24" viewBox="0 0 24 24">
                        <path d="M15 18l-6-6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                <button class="splide__arrow splide__arrow--next" type="button" aria-label="Tolesni produktai">
                    <svg width="24" height="24" viewBox="0 0 24 24">
                        <path d="M9 18l6-6-6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            `;
            sliderWrapper.appendChild(arrows);
            
            // Replace the old list with the slider wrapper
            productsList.parentNode.replaceChild(sliderWrapper, productsList);
            
            // Card width stays a quarter of the row. A short list must not
            // stretch one product across the whole section.
            const desktopPerPage = 4;
            const shouldSlideDesktop = productItems.length > desktopPerPage;

            // Initialize Splide
            const sliderOptions = {
                type: shouldSlideDesktop ? 'loop' : 'slide',
                perPage: desktopPerPage,
                perMove: 1,
                autoplay: false,
                pauseOnHover: true,
                arrows: shouldSlideDesktop,
                drag: shouldSlideDesktop,
                pagination: false,
                gap: '2rem',
                i18n: {
                    prev: 'Ankstesni produktai',
                    next: 'Tolesni produktai',
                    first: 'Pirmi produktai',
                    last: 'Ankstesni produktai'
                },
                breakpoints: {
                    1199: {
                        perPage: 3,
                        gap: '1.5rem',
                        arrows: productItems.length > 3,
                        drag: productItems.length > 3
                    },
                    991: {
                        perPage: 2,
                        gap: '1.5rem',
                        arrows: productItems.length > 2,
                        drag: productItems.length > 2
                    },
                    576: {
                        perPage: 2,
                        gap: '0.625rem',
                        arrows: productItems.length > 2,
                        drag: productItems.length > 2,
                        type: productItems.length > 2 ? 'loop' : 'slide'
                    }
                }
            };
            
            const splide = new Splide(sliderWrapper, sliderOptions);
            splide.mount();

            // Ensure initial alignment after layout/images are ready.
            // (No slide removal/hiding; we prevented empties at the source.)
            splide.on('mounted', () => {
                requestAnimationFrame(() => splide.refresh());
            });
        }
    }

    function initProductBundle() {
        const cfg = window.bpProductBundle;
        const root = document.querySelector('.bp-bundle');
        if (!cfg || !root || !Array.isArray(cfg.elves) || cfg.elves.length === 0) {
            return;
        }

        const i18n = cfg.i18n || {};
        const letterForm = root.querySelector('.bp-bundle__letter form.cart');
        const elfHosts = Array.from(root.querySelectorAll('.bp-bundle__elf-form'));
        const typesWrap = root.querySelector('.bp-bundle__types');
        const summary = root.querySelector('.bp-bundle__summary');
        const errorEl = root.querySelector('.bp-bundle__error');
        const backBtn = root.querySelector('.bp-bundle__back');
        const nextBtn = root.querySelector('.bp-bundle__next');
        const stepsNav = root.querySelector('.bp-bundle__steps');
        if (!letterForm || !typesWrap || !backBtn || !nextBtn) {
            return;
        }

        root.querySelectorAll('form.cart').forEach(function (form) {
            form.addEventListener('submit', function (event) {
                event.preventDefault();
            });
        });

        let selectedElfId = 0;
        const hasKit = cfg.elves.some(function (elf) { return elf.kind === 'kit'; });
        const hasElf = cfg.elves.some(function (elf) { return elf.kind !== 'kit'; });
        typesWrap.innerHTML = '';

        function cardsFor(kind) {
            if (hasKit && hasElf) {
                let group = typesWrap.querySelector('[data-kind="' + kind + '"] .kp-elf-wizard__cards');
                if (group) {
                    return group;
                }
                const wrap = document.createElement('div');
                wrap.className = 'bp-bundle__type-group';
                wrap.setAttribute('data-kind', kind);
                wrap.innerHTML = '<h3 class="bp-bundle__type-title">' + escapeHtml(kind === 'kit' ? (i18n.elfKit || 'Elf kit') : (i18n.elf || 'Elf')) + '</h3><div class="kp-elf-wizard__cards kp-elf-wizard__cards--types"></div>';
                typesWrap.appendChild(wrap);
                return wrap.querySelector('.kp-elf-wizard__cards');
            }
            let cards = typesWrap.querySelector('.kp-elf-wizard__cards');
            if (!cards) {
                cards = document.createElement('div');
                cards.className = 'kp-elf-wizard__cards kp-elf-wizard__cards--types';
                typesWrap.appendChild(cards);
            }
            return cards;
        }

        cfg.elves.forEach(function (elf) {
            const kind = elf.kind === 'kit' ? 'kit' : 'elf';
            const card = document.createElement('button');
            card.type = 'button';
            card.className = 'kp-elf-choice-card';
            card.setAttribute('data-elf-id', String(elf.id));
            card.innerHTML =
                '<span class="kp-elf-choice-card__mark" aria-hidden="true"></span>' +
                (elf.image ? '<div class="kp-elf-choice-card__media"><img src="' + escapeHtml(elf.image) + '" alt="' + escapeHtml(elf.title || '') + '"></div>' : '') +
                '<div class="kp-elf-choice-card__body">' +
                    '<h3 class="kp-elf-choice-card__title">' + escapeHtml(elf.title || '') + '</h3>' +
                    '<p class="kp-elf-choice-card__price">' + formatEuro(Number(elf.price) || 0) + '</p>' +
                '</div>';
            card.addEventListener('click', function () {
                selectedElfId = elf.id;
                typesWrap.querySelectorAll('.kp-elf-choice-card').forEach(function (other) {
                    const on = other === card;
                    other.classList.toggle('is-selected', on);
                    other.setAttribute('aria-pressed', on ? 'true' : 'false');
                });
                elfHosts.forEach(function (host) {
                    host.hidden = String(host.getAttribute('data-elf-id')) !== String(elf.id);
                });
                showError('');
                updateSummary();
                refreshAction();
            });
            cardsFor(kind).appendChild(card);

            const host = elfHosts.find(function (node) {
                return String(node.getAttribute('data-elf-id')) === String(elf.id);
            });
            const form = host ? host.querySelector('form.cart') : null;
            if (form && kind === 'kit' && elf.kit) {
                initElfWizard(form, elf.kit);
            } else if (form && elf.gender) {
                initElfWizard(form, elf.gender);
            }
            if (form) {
                form.querySelectorAll('.wapf-field-container').forEach(function (container) {
                    if (!container.classList.contains('kp-elf-wizard-field')) {
                        const field = container.querySelector('input, select, textarea');
                        if (field) {
                            container.classList.add('bp-bundle-elf-extra');
                        }
                    }
                });
            }
        });

        const hasLetterExtras = letterForm.classList.contains('kp-letter-wizard');
        const hasElfExtras = elfHosts.some(function (host) {
            return !!host.querySelector('.bp-bundle-elf-extra');
        });
        const steps = [{ id: 'child', label: i18n.child || 'Child details' }];
        if (hasLetterExtras) {
            steps.push({ id: 'extras', label: i18n.extras || 'Letter extras' });
        }
        const companionLabel = hasKit && hasElf
            ? (i18n.elfOrKit || 'Elf or kit')
            : (hasKit ? (i18n.elfKit || 'Elf kit') : (i18n.elf || 'Elf'));
        steps.push({ id: 'elf', label: companionLabel });
        if (hasElfExtras) {
            steps.push({ id: 'elf-extras', label: i18n.elfExtras || 'Elf extras' });
        }

        stepsNav.innerHTML = '<ol class="bp-bundle__steps-list"></ol>';
        const stepsList = stepsNav.querySelector('ol');
        steps.forEach(function (step, index) {
            const li = document.createElement('li');
            li.className = 'bp-bundle__step';
            li.setAttribute('data-step-id', step.id);
            li.innerHTML = '<span class="bp-bundle__step-num">' + (index + 1) + '</span><span class="bp-bundle__step-label">' + escapeHtml(step.label) + '</span>';
            stepsList.appendChild(li);
        });

        let stepIndex = 0;

        function currentStep() {
            return steps[stepIndex];
        }

        function selectedElf() {
            return cfg.elves.find(function (elf) {
                return elf.id === selectedElfId;
            }) || null;
        }

        function selectedElfForm() {
            const host = elfHosts.find(function (node) {
                return String(node.getAttribute('data-elf-id')) === String(selectedElfId);
            });
            return host ? host.querySelector('form.cart') : null;
        }

        function showError(message) {
            if (!errorEl) {
                return;
            }
            errorEl.textContent = message || '';
            errorEl.hidden = !message;
        }

        function extraTotal(form, selector) {
            if (!form) {
                return 0;
            }
            let total = 0;
            form.querySelectorAll(selector).forEach(function (select) {
                total += selectedOptionPrice(select);
            });
            return total;
        }

        function checkedBoxTotal(form) {
            if (!form) {
                return 0;
            }
            let total = 0;
            form.querySelectorAll('input.wapf-input[type="checkbox"]:checked').forEach(function (input) {
                const price = parseFloat(input.getAttribute('data-wapf-price') || '');
                if (!isNaN(price) && price > 0) {
                    total += price;
                }
            });
            return total;
        }

        function selectedHasExtras() {
            const form = selectedElfForm();
            return !!(form && form.querySelector('.bp-bundle-elf-extra'));
        }

        function stepIsLast() {
            const step = currentStep();
            if (stepIndex === steps.length - 1) {
                return true;
            }
            return step.id === 'elf' && !!selectedElfId && !selectedHasExtras();
        }

        function refreshAction() {
            nextBtn.textContent = stepIsLast() ? (i18n.add || 'Add to cart') : (i18n.next || 'Continue');
        }

        function updateSummary() {
            const elf = selectedElf();
            const elfPrice = elf ? (Number(elf.price) || 0) : 0;
            const primaryPrice = Number(cfg.primaryPrice) || 0;
            const discountAmount = Number(cfg.discountAmount) || 0;
            const pair = primaryPrice + elfPrice;
            let off = 0;
            if (elf) {
                if (cfg.discountType === 'percent') {
                    off = pair * (discountAmount / 100);
                } else {
                    off = Math.min(discountAmount, pair);
                }
                off = Math.round(off * 100) / 100;
            }
            const extras = extraTotal(letterForm, '.kp-letter-wizard-field--extra select') + extraTotal(selectedElfForm(), 'select.wapf-input') + checkedBoxTotal(selectedElfForm());
            const total = Math.max(0, pair - off + extras);
            const lines = [
                '<div><span>' + escapeHtml(i18n.letter || '') + '</span><span>' + formatEuro(primaryPrice) + '</span></div>'
            ];
            if (elf) {
                lines.push('<div><span>' + escapeHtml(elf.title || i18n.elf || '') + '</span><span>' + formatEuro(elfPrice) + '</span></div>');
            }
            if (extras > 0.001) {
                lines.push('<div><span>' + escapeHtml(i18n.extrasLine || '') + '</span><span>' + formatEuro(extras) + '</span></div>');
            }
            if (off > 0.001) {
                lines.push('<div class="is-discount"><span>' + escapeHtml(i18n.discount || '') + '</span><span>−' + formatEuro(off) + '</span></div>');
            }
            lines.push('<div class="is-total"><span>' + escapeHtml(i18n.total || '') + '</span><span>' + formatEuro(total) + '</span></div>');
            summary.innerHTML = lines.join('');
        }

        function setStep(index, silent) {
            stepIndex = Math.max(0, Math.min(steps.length - 1, index));
            const step = currentStep();
            root.setAttribute('data-step', step.id);
            letterForm.classList.toggle('kp-letter-wizard--step-1', step.id === 'child');
            letterForm.classList.toggle('kp-letter-wizard--step-2', step.id === 'extras');
            stepsList.querySelectorAll('.bp-bundle__step').forEach(function (el, i) {
                el.classList.toggle('is-active', i === stepIndex);
                el.classList.toggle('is-complete', i < stepIndex);
            });
            backBtn.hidden = stepIndex === 0;
            refreshAction();
            nextBtn.disabled = false;
            showError('');
            updateSummary();
            if (!silent && typeof root.scrollIntoView === 'function') {
                root.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }

        function childFieldsValid() {
            const fields = letterForm.querySelectorAll('.kp-letter-wizard-field--child input, .kp-letter-wizard-field--child select, .kp-letter-wizard-field--child textarea');
            const list = fields.length ? fields : letterForm.querySelectorAll('.wapf-field-container input, .wapf-field-container select, .wapf-field-container textarea');
            for (let i = 0; i < list.length; i++) {
                const field = list[i];
                if (field.closest('.kp-letter-wizard-field--extra') || field.closest('.bp-bundle-elf-extra')) {
                    continue;
                }
                if (fieldIsCheckable(field) && !field.checkValidity()) {
                    showFieldNotice(field);
                    return false;
                }
            }
            return true;
        }

        function elfStepValid() {
            if (!selectedElfId) {
                showError(i18n.chooseElf || '');
                return false;
            }
            const form = selectedElfForm();
            const genderBlock = form ? form.querySelector('.kp-elf-wizard__gender') : null;
            const genderCard = form ? form.querySelector('.kp-elf-wizard__cards--gender .is-selected') : null;
            const needsGender = genderBlock && !genderBlock.hidden;
            if (needsGender && !genderCard) {
                showError(i18n.chooseGender || '');
                return false;
            }
            return true;
        }

        function formPayload(form) {
            const wapf = {};
            let groups = '';
            if (!form) {
                return { wapf: wapf, wapf_field_groups: groups };
            }
            const data = new FormData(form);
            data.forEach(function (value, key) {
                // Checkbox groups post as wapf[field_x][] (one entry per tick plus
                // WAPF's hidden "0" placeholders); keep them as an array like a
                // normal form submit would.
                const multi = key.match(/^wapf\[([^\]]+)\]\[\]$/);
                if (multi) {
                    if (!Array.isArray(wapf[multi[1]])) {
                        wapf[multi[1]] = [];
                    }
                    wapf[multi[1]].push(value);
                    return;
                }
                const single = key.match(/^wapf\[([^\]]+)\]$/);
                if (single) {
                    wapf[single[1]] = value;
                    return;
                }
                if (key === 'wapf_field_groups') {
                    groups = String(value);
                }
            });
            return { wapf: wapf, wapf_field_groups: groups };
        }

        function submitBundle() {
            if (!elfStepValid()) {
                return;
            }
            showError('');
            nextBtn.disabled = true;
            const body = new FormData();
            body.append('action', 'bp_bundle_add_to_cart');
            body.append('nonce', cfg.nonce || '');
            body.append('bundle_id', String(cfg.bundleId || ''));
            body.append('elf_id', String(selectedElfId));
            body.append('primary_fields', JSON.stringify(formPayload(letterForm)));
            body.append('elf_fields', JSON.stringify(formPayload(selectedElfForm())));
            fetch(cfg.ajaxUrl, {
                method: 'POST',
                body: body,
                credentials: 'same-origin'
            }).then(function (response) {
                return response.json();
            }).then(function (payload) {
                if (!payload || !payload.success) {
                    showError((payload && payload.data && payload.data.message) || i18n.failed || '');
                    nextBtn.disabled = false;
                    return;
                }
                const fragments = payload.data && payload.data.fragments ? payload.data.fragments : {};
                Object.keys(fragments).forEach(function (selector) {
                    document.querySelectorAll(selector).forEach(function (node) {
                        node.outerHTML = fragments[selector];
                    });
                });
                document.body.dispatchEvent(new Event('added_to_cart'));
            }).catch(function () {
                showError(i18n.failed || '');
                nextBtn.disabled = false;
            });
        }

        backBtn.addEventListener('click', function () {
            setStep(stepIndex - 1);
        });
        nextBtn.addEventListener('click', function () {
            const step = currentStep();
            if (step.id === 'child' && !childFieldsValid()) {
                return;
            }
            if ((step.id === 'elf' || step.id === 'elf-extras') && !elfStepValid()) {
                return;
            }
            if (stepIsLast()) {
                submitBundle();
                return;
            }
            setStep(stepIndex + 1);
        });
        root.addEventListener('change', updateSummary);
        setStep(0, true);
        if (cfg.elves.length === 1) {
            const onlyCard = typesWrap.querySelector('.kp-elf-choice-card');
            if (onlyCard) {
                onlyCard.click();
            }
        }
    }
});
